__webpack_require__.p = "/direction/static_content/assets/magne/tests/deficit-magne/";